'use es6';

import { createSelector } from 'reselect';
export const getUser = state => state.auth && state.auth.user;
export const getUserVerifiedAt = createSelector(getUser, user => user && user.verifiedAt || 0);